import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import {
  FILTER_PERIOD,
  FILTER_AFFILIATES,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
} from 'scenes/Annotations/constants';

import * as Filters from './filters';

export const PRIMARY_FILTERS = [
  FILTER_PERIOD,
  FILTER_AFFILIATES,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
];

const PrimaryFilters = () => (
  <PrimaryFiltersProvider primary={PRIMARY_FILTERS}>
    <Filters.Period />
    <Filters.Affiliates dropdownWidth={'440px'} withClear={true} />
    <Filters.Applications withClear={true} />
    <Filters.Networks withClear={true} />
    <Filters.Clusters withClear={true} />
    <Filters.Platforms withClear={true} />
    <Filters.Type withClear={true} />
    <Filters.SubTypes withClear={true} />
    <Filters.Channels withClear={true} />
    <Filters.OnlyMine withClear={true} />
  </PrimaryFiltersProvider>
);

export default PrimaryFilters;
